import './index.css'
import translate from '@/utils/translate';
export default {
    props: ['total','current'],
    data(){
        return {
            jumpNum:null
        }
    },
    methods:{
        goPage(i){
            i=parseInt(i)
            if(!i||i>this.total||i<1){
                return
            }
            this.$emit("change",i)
        }
    },
    render() {
        var total=parseInt(this.total)||1
        var current=parseInt(this.current)||1
        var numMap=Array(this.total).fill(null).map((_,i)=>i+1)
        if(current+3<total){
            numMap=[...numMap.slice(0,current+2),null,total]
        }
        if(current-3>1){
            numMap=[1,null,...numMap.slice(current-2)]
        }
        return (
            <div class="cd-pagination">
                <ul>
                    <li class={['item',this.current<=1&&'disable']} onClick={()=>this.goPage(current-1)}>
                        <img src="//img10.joybuy.com/uba/jfs/t20077/259/612310184/321/48f528a8/5b028b37N96fe89e7.png" />
                    </li>
                    {numMap.map(index=>index?(
                        <li class={['item',index==this.current&&'active']} onClick={()=>this.goPage(index)}>{index}</li>
                    ):(
                        <li class="item disable">...</li>
                    ))}
                    <li class={['item',this.current>=this.total&&'disable']} onClick={()=>this.goPage(current+1)}>
                        <img src="//img10.joybuy.com/uba/jfs/t19063/169/2624257808/264/e4af0fe/5b028b37N94281bdb.png" />
                    </li >
                </ul >
                <span>
                    <span>{translate('Go to page')}</span>
                    <div class="item">
                        <input class="paging-num" value={this.jumpNum} onInput={e=>this.jumpNum=e.target.value}  />
                    </div>
                    <div class="item paging-btn" onClick={()=>this.goPage(this.jumpNum)}>{translate('GO')}</div>
                </span>
            </div>
        )
    }
}